import { Component, OnDestroy, OnInit } from '@angular/core';
import { Event } from '@rensa/modules/customer/models/event.model';
import { ListItem } from '@rensa/modules/customer/models/list-item.model';
import { ActivatedRoute } from '@angular/router';
import { ItemService } from '@rensa/modules/customer/services/item.service';
import { HttpErrorResponse } from '@angular/common/http';
import { BaseController } from '@rensa/shared/base-controller';
import { MessageType } from '@rensa/shared/components/feedback/feedback.component';

@Component({
  selector: 'app-unregister',
  templateUrl: './unregister.component.html',
  styleUrls: ['./unregister.component.css']
})
export class UnregisterComponent extends BaseController implements OnInit, OnDestroy {

  eventId: string;
  trainingId: string;
  userId: string;
  MessageType = MessageType;

  unregisterSuccess = false;
  disableButton = false;

  event: Event;
  training: ListItem;

  unregisterError: string;

  constructor(
    private route: ActivatedRoute,
    private trainingService: ItemService,
  ) {
    super();
    this.addSubscription(route.params.subscribe(next => {
      this.eventId = next.eventId;
      this.trainingId = next.trainingId;
      this.userId = next.userId;
      if (this.trainingId) {
        this.trainingService.fetchBy(this.trainingId)
          .toPromise()
          .then((training: ListItem) => {
            this.training = training;
            this.event = this.training.events.find(element => element.id === this.eventId);
          })
          .catch(error => console.error(error));
      }
    }));
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this._ngOnDestroy();
  }

  unregister(): void {
    this.disableButton = true;
    this.unregisterError = null;
    this.unregisterSuccess = false;
    this.trainingService.unregister(this.trainingId, this.eventId, this.userId)
      .toPromise()
      .then(() => this.unregisterSuccess = true)
      .catch((error: HttpErrorResponse) => this.unregisterError = error.message)
      .finally(() => this.disableButton = false);
  }
}
